var exports = {
  "kL": "x31de4314--c17a1e--container",
  "Qs": "x31de4314--c17a1e--content",
  "Sl": "x31de4314--c17a1e--image",
  "DD": "x31de4314--c17a1e--title",
  "h_": "x31de4314--c17a1e--description",
};

module.exports = exports;
